import { Client, generateClient } from 'aws-amplify/api';
import React, { createContext, useMemo } from 'react';
import { useAuth } from './AuthProvider';

interface AmplifyApiClientState {
  client: Client;
}

export const AmplifyApiClientContext = createContext<AmplifyApiClientState | null>(null);

interface AmplifyApiClientProps {
  children: React.ReactNode;
}

export const AmplifyApiClientProvider = ({ children }: AmplifyApiClientProps) => {
  const { user } = useAuth();

  const client = useMemo(() => {
    return generateClient();
  }, [user]);

  return (
    <AmplifyApiClientContext.Provider value={{ client }}>
      {children}
    </AmplifyApiClientContext.Provider>
  );
};
